import api from "./api";
import { ServiceRequest, ServiceRequestPayload } from "../types/store";

export const createServiceRequest = async (payload: ServiceRequestPayload) => {
  const response = await api.post<ServiceRequest>("/services/requests", payload);
  return response.data;
};

export const fetchMyServiceRequests = async () => {
  const response = await api.get<ServiceRequest[]>("/services/requests/me");
  return response.data;
};
